const topicAttachmentsPattern = /{surveyImages:((?:[^;}];?)+)}/;

export default topicAttachmentsPattern;